import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { convertToNerdMenu } from '../nerd_menu/NerdMenu';
import { NerdMenuElements } from '../nerd_menu/nerd_menu_footer/NerdMenuElements';
import NerdMenuFooterUtility from '../nerd_menu/nerd_menu_footer/NerdMenuFooterUtility';
import NerdMenuStacked from '../nerd_menu/nerd_menu_footer/NerdMenuStacked';

interface FooterProps {
  // for now let's not use theme
  // theme: string;
  menu: NerdMenuDrupalEdges;
  utilityMenu: NerdMenuDrupalEdges;
}

const UpperFooter = ({ menus }: { menus: NerdMenu }) => {
  return (
    <div>
      <div className="pds-container pds-hidden md:pds-flex md:pds-gap-5 lg:pds-gap-6">
        <NerdMenuElements menuElements={menus.menuElements} />
      </div>
      <div className="pds-block md:pds-hidden">
        <NerdMenuStacked nerdMenu={menus} />
      </div>
    </div>
  );
};

const LowerFooter = ({ menus }: { menus: NerdMenu }) => {
  return (
    <ul className="pds-container pds-m-0 pds-flex pds-flex-col pds-gap-4 pds-p-0 md:pds-flex-row md:pds-flex-wrap md:pds-items-center md:pds-gap-x-5 md:pds-gap-y-1">
      <NerdMenuFooterUtility menus={menus.menuElements} />
    </ul>
  );
};

const FooterWithNerdMenu: React.FC<FooterProps> = function ({
  menu: nerdMenuDrupal,
  utilityMenu: utilityMenuDrupal,
}) {
  const { t } = useTranslation();

  const menus = convertToNerdMenu(nerdMenuDrupal);
  const lowerMenus = convertToNerdMenu(utilityMenuDrupal);

  return (
    <footer
      aria-label={t('footer')}
      role="contentinfo"
      className="pds-bg-neutral pds-p-4.5 not-first:pds-space-y-5 md:pds-p-5.5"
    >
      <UpperFooter menus={menus} />
      <hr
        className="pds-hidden pds-border-neutral-text pds-pb-4.5 pds-opacity-[1] md:pds-block"
        aria-hidden
      />
      <div className="md:!pds-mt-0">
        <LowerFooter menus={lowerMenus} />
      </div>
      <p className="pds-text-body-sm pds-text-neutral-text">
        {t(
          'All Nestlé Purina trademarks owned by Société des Produits Nestlé S.A., Vevey, Switzerland or are used with permission.',
        )}
      </p>
    </footer>
  );
};

export default FooterWithNerdMenu;
